
import React, { useEffect } from 'react';
import {
    MDBFooter,
    MDBContainer,
    MDBRow,
    MDBCol
} from 'mdb-react-ui-kit';
import { MDBIcon } from 'mdbreact';
import {
    Link,
    useNavigate,
    useLocation
} from 'react-router-dom';

import PhoneRing from '../../components/PhoneRing';
import "../../css/Footer.css";
export default function FooterTest() {
    const navigate = useNavigate();
    const location = useLocation();

    // Cuộn lên đầu trang khi đường dẫn thay đổi
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [location.pathname]);

    // Xử lý khi bấm Trang chủ
    const handleHomeClick = (e) => {
        e.preventDefault();

        if (location.pathname === '/') {
            // Đang ở trang chủ thì chỉ cuộn lên đầu
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        } else {
            // Đang ở trang khác thì về trang chủ
            navigate('/');
        }
    };

    return (
        <MDBFooter
            bgColor="light"
            className="text-center text-lg-start text-muted"
        >
            {/* Mạng xã hội */}
            <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
                <div className="me-5 d-none d-lg-block">
                    <span>
                        Liên lạc với tôi qua các trang mạng xã hội:
                    </span>
                </div>

                <div>
                    <a
                        href="https://www.facebook.com/MinMinMedia01?mibextid=LQQJ4d"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-4 text-reset"
                        aria-label="Facebook MinMin Wedding"
                    >
                        <MDBIcon fab icon="facebook-f" />
                    </a>

                    <a
                        href="https://www.youtube.com/@thien_minweddingfilm6102"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-4 text-reset"
                        aria-label="YouTube MinMin Wedding"
                    >
                        <MDBIcon fab icon="youtube" />
                    </a>
                </div>
            </section>

            {/* Nội dung Footer */}
            <section>
                <MDBContainer fluid className="text-center text-md-start mt-5 footer-container">
                    <MDBRow className="mt-3">

                        {/* Giới thiệu */}
                        <MDBCol
                            md="3"
                            lg="4"
                            xl="3"
                            className="mx-auto mb-4"
                        >
                            <h6 className="text-uppercase fw-bold mb-4">
                                <MDBIcon
                                    icon="gem"
                                    className="me-3"
                                />
                                MinMin Wedding - Phóng Sự Cưới
                            </h6>

                            <p>
                                MinMin Wedding - Phóng Sự Cưới cung cấp
                                dịch vụ Quay - Chụp Lễ - Tiệc đám cưới,
                                Phóng sự cưới, Event, Tiệc sinh nhật,
                                Lễ khai trương, TeamBuilding.
                            </p>
                        </MDBCol>

                        {/* Đường dẫn */}
                        <MDBCol
                            md="3"
                            lg="2"
                            xl="2"
                            className="mx-auto mb-4"
                        >
                            <h6 className="text-uppercase fw-bold mb-4">
                                Đường dẫn
                            </h6>

                            <p>
                                <a
                                    href="/"
                                    onClick={handleHomeClick}
                                    className="text-reset footer-link"
                                >
                                    TRANG CHỦ
                                </a>
                            </p>

                            <p>
                                <Link
                                    to="/service"
                                    className="text-reset footer-link"
                                >
                                    DỊCH VỤ
                                </Link>
                            </p>

                            <p>
                                <Link
                                    to="/banggiachup"
                                    className="text-reset footer-link"
                                >
                                    BẢNG GIÁ CHỤP
                                </Link>
                            </p>

                            <p>
                                <Link
                                    to="/banggiaquay"
                                    className="text-reset footer-link"
                                >
                                    BẢNG GIÁ QUAY
                                </Link>
                            </p>

                            <p>
                                <Link
                                    to="/banggiaquaychup"
                                    className="text-reset footer-link"
                                >
                                    BẢNG GIÁ QUAY CHỤP
                                </Link>
                            </p>
                        </MDBCol>

                        {/* Liên hệ */}
                        <MDBCol
                            md="4"
                            lg="3"
                            xl="3"
                            className="mx-auto mb-md-0 mb-4 footer-contact"
                        >
                            <h6 className="text-uppercase fw-bold mb-4">
                                Liên lạc
                            </h6>

                            <p className="footer-contact-item">
                                <MDBIcon
                                    icon="home"
                                    className="footer-contact-icon"
                                />
                                <span>
                                    <strong>Địa Chỉ Home:</strong>
                                    <br />
                                    163D Đặng Thúc Vịnh, Ấp 38,
                                    xã Đông Thạnh, TP.HCM
                                </span>
                            </p>

                            <p className="footer-contact-item">
                                <MDBIcon
                                    icon="building"
                                    className="footer-contact-icon"
                                />
                                <span>
                                    <strong>Địa Chỉ Studio:</strong>
                                    <br />
                                    275 Nguyễn Văn Quá,
                                    P. Đông Hưng Thuận, Q.12, TP.HCM
                                </span>
                            </p>

                            <p className="footer-contact-item">
                                <MDBIcon
                                    icon="envelope"
                                    className="footer-contact-icon"
                                />
                                <a
                                    href="mailto:thienphan3030@gmail.com"
                                    className="text-reset"
                                >
                                    thienphan3030@gmail.com
                                </a>
                            </p>

                            <p className="footer-contact-item">
                                <MDBIcon
                                    icon="phone"
                                    className="footer-contact-icon"
                                />
                                <a
                                    href="tel:0703427959"
                                    className="text-reset"
                                >
                                    0703427959
                                </a>
                            </p>
                        </MDBCol>

                    </MDBRow>
                </MDBContainer>
            </section>

            {/* Bản quyền */}
            <div
                className="text-center p-4"
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                }}
            >
                © 2023 Copyright:{' '}
                <Link
                    to="/"
                    onClick={handleHomeClick}
                    className="text-reset fw-bold footer-link"
                >
                    MinMin Wedding - Phóng Sự Cưới
                </Link>
            </div>

            <PhoneRing />
        </MDBFooter>
    );
}
